import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class NotifyAddPurchaserEmail extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onAddEmail: PropTypes.func,
    isMobile: PropTypes.bool,
  }

  handleOnClose = (e) => {
    this.props.onClose(e);
  }

  handleOnAddEmail = (e) => {
    this.props.onAddEmail(e);
  }

  render() {
    const { isMobile, t } = this.props;
    return (
      <Modal
        size={isMobile ? 'small' : 'tiny'}
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Modal.Content>
          <Modal.Description>
            <Grid centered>
              <Grid.Row>
                <Grid.Column mobile={2} tablet={2} computer={2} textAlign="right" verticalAlign="middle">
                  <Icon name="info circle" color="green" size="big" inverted />
                </Grid.Column>
                <Grid.Column mobile={14} tablet={14} computer={14} textAlign="left">
                  {t('Please fill in customer\'s email at Purchaser tab above so that your customer may receive payment link via email')}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={this.handleOnClose} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button color="green" onClick={this.handleOnAddEmail} content={t('Add Email')} />
        </Modal.Actions>
      </Modal>
    )
  }
}
export default withTranslation(namespaces)(NotifyAddPurchaserEmail);



// WEBPACK FOOTER //
// ./src/containers/modals/NotifyAddPurchaserEmail.jsx